export function EmailVehicleVisualsCtrl (
  $scope,
  $translate,
  $uibModalInstance,
  email,
  messages,
  messengerApi,
  url,
  visual
) {
  $scope.email = {
    email_address: email,
    body         : $translate.instant('JS_SPACE.VEHICLE_VISUALS.EMAIL_BODY', {
      desc : visual.description || visual.description_en_AU,
      line : '<br>',
      link : `<a href="${url}" target="_blank">here</a>`,
      title: visual.title || visual.en_AU
    }),
    subject: $translate.instant('JS_SPACE.VEHICLE_VISUALS.EMAIL_SUBJECT', {
      title: visual.title || visual.en_AU
    })
  };

  $scope.send = function () {
    $scope.sending = true;

    messengerApi.sendEmail($scope.email)
    .then(() => {
      $uibModalInstance.close();
    }).catch(err => {
      messages.error(err);
    }).finally(() => {
      $scope.sending = false;
    });
  };
}